import { axios } from "@/utils";
import { data } from "react-router";

export const AlertListService = async (params: any) => {
  return await axios.get("/monitrees-monitor-bff/monitor/alerts", {
    params: params,
  });
};
